// Mock data for Space Data website

export const translations = {
  en: {
    nav: {
      services: 'Services',
      technology: 'Technology',
      industries: 'Industries',
      about: 'About',
      contact: 'Contact',
      getQuote: 'Get A Quote'
    },
    hero: {
      title: 'Professional Drone Surveying Services',
      subtitle: 'Precision LiDAR and Photogrammetry Solutions for Albania',
      description: 'Licensed drone surveying company delivering high-accuracy data capture for construction sites, cadastral work, powerline inspection, and 3D modeling projects.',
      cta: 'Request A Quote',
      cta2: 'Our Services'
    },
    services: {
      title: 'Our Specialized Services',
      subtitle: 'Advanced drone technology meets professional surveying expertise',
      items: [
        {
          title: 'LiDAR Surveying',
          description: 'High-precision 3D terrain mapping with point cloud data capture. Ideal for large-scale topographic surveys and complex terrain analysis.',
          icon: 'Scan'
        },
        {
          title: 'Photogrammetry',
          description: 'Aerial imagery processing for accurate orthomosaic maps, digital surface models, and detailed site documentation.',
          icon: 'Camera'
        },
        {
          title: 'Construction Monitoring',
          description: 'Track project progress with regular drone surveys. Measure earthwork volumes, monitor milestones, and ensure quality control.',
          icon: 'Building2'
        },
        {
          title: 'Cadastral Surveys',
          description: 'Precise property boundary mapping and land registry documentation. Full compliance with Albanian cadastral standards.',
          icon: 'MapPin'
        },
        {
          title: 'Powerline Inspection',
          description: 'Safe and efficient inspection of transmission lines, towers, and electrical infrastructure without service interruption.',
          icon: 'Zap'
        },
        {
          title: '3D Modeling',
          description: 'Create detailed 3D models of buildings, infrastructure, and terrain for planning, design, and documentation.',
          icon: 'Box'
        }
      ]
    },
    technology: {
      title: 'Cutting-Edge LiDAR Technology',
      subtitle: 'Unparalleled accuracy and detail',
      description: 'Our advanced LiDAR sensors capture millions of data points per second, delivering centimeter-level accuracy for demanding surveying projects. We combine state-of-the-art drone platforms with professional-grade sensors to provide the most reliable aerial data capture services in Albania.',
      features: [
        'Centimeter-level accuracy',
        'Rapid data acquisition',
        'All-weather capability',
        'Vegetation penetration'
      ],
      cta: 'Learn More'
    },
    industries: {
      title: 'Industries We Serve',
      subtitle: 'Specialized solutions across multiple sectors',
      items: [
        {
          title: 'Construction & Development',
          description: 'Site planning, progress monitoring, volumetric calculations, and as-built documentation for residential, commercial, and infrastructure projects.',
          icon: 'HardHat'
        },
        {
          title: 'Energy & Utilities',
          description: 'Power line inspection, solar farm monitoring, wind turbine assessment, and transmission corridor mapping.',
          icon: 'Zap'
        },
        {
          title: 'Agriculture',
          description: 'Crop monitoring, irrigation planning, land management, and precision agriculture applications.',
          icon: 'Sprout'
        },
        {
          title: 'Mining & Quarries',
          description: 'Stockpile volume measurement, pit progression monitoring, and safety compliance documentation.',
          icon: 'Mountain'
        }
      ]
    },
    about: {
      title: 'About Space Data',
      mission: {
        title: 'Our Mission',
        description: 'We stand for unbound progress – unlocking the full potential of drone technology and executing complex challenges across Albania. We live at the forefront of technology and industry – piloting towards a limitless future.'
      },
      why: {
        title: 'Why Space Data',
        description: 'Our comprehensive systems, abundant resources, experienced pilots, and stringent safety measures fully equip us to execute any mission successfully. We make superior aerial data more accessible and affordable so our partners can have the insights they need to innovate, grow, and adapt. Our unwavering standards of accuracy and reliability help drive our customer service – forging trusted, collaborative partnerships that span the country and fuel progress.'
      }
    },
    why: {
      title: 'Why Choose Space Data',
      items: [
        {
          title: 'Licensed & Certified',
          description: 'Fully licensed drone operators with professional surveying credentials',
          icon: 'Award'
        },
        {
          title: 'Fast Turnaround',
          description: 'Rapid data collection and processing with delivery in days, not weeks',
          icon: 'Clock'
        },
        {
          title: 'Precision Guaranteed',
          description: 'Industry-leading accuracy standards with quality control protocols',
          icon: 'Target'
        },
        {
          title: 'Local Expertise',
          description: 'Deep knowledge of Albanian terrain, regulations, and project requirements',
          icon: 'Map'
        }
      ]
    },
    contact: {
      title: 'Get A Quote',
      subtitle: 'Ready to start your project? Contact us today',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email Address',
        phone: 'Phone Number',
        company: 'Company Name',
        projectType: 'Project Type',
        projectTypes: [
          'LiDAR Survey',
          'Photogrammetry',
          'Construction Monitoring',
          'Cadastral Survey',
          'Powerline Inspection',
          '3D Modeling',
          'Other'
        ],
        description: 'Project Description',
        descriptionPlaceholder: 'Please describe your project, location, area coverage, and any specific requirements...',
        timeline: 'When is the project needed?',
        submit: 'Submit Request',
        success: 'Thank you! We will contact you within 24 hours.',
        error: 'Please fill in all required fields.'
      }
    },
    footer: {
      tagline: 'Professional drone surveying services across Albania',
      services: 'Services',
      company: 'Company',
      companyLinks: ['About Us', 'Careers', 'Partners', 'News'],
      contact: 'Contact',
      rights: 'All rights reserved.',
      address: 'Tirana, Albania',
      email: 'info@spacedata.al',
      phone: '+355 69 242 2682'
    }
  },
  sq: {
    nav: {
      services: 'Shërbimet',
      technology: 'Teknologjia',
      industries: 'Industritë',
      about: 'Rreth Nesh',
      contact: 'Kontakti',
      getQuote: 'Kërkoni Ofertë'
    },
    hero: {
      title: 'Shërbime Profesionale Matjeje me Dron',
      subtitle: 'Zgjidhje Precize LiDAR dhe Fotogrametri për Shqipërinë',
      description: 'Kompani e licensuar për matje me dron që ofron kapur të dhënash me saktësi të lartë për kantiere ndërtimi, punë kadastrale, inspektim linjash të energjisë, dhe projekte modelimi 3D.',
      cta: 'Kërkoni Ofertë',
      cta2: 'Shërbimet Tona'
    },
    services: {
      title: 'Shërbimet Tona të Specializuara',
      subtitle: 'Teknologji e avancuar dronësh takohet me ekspertizë profesionale matjeje',
      items: [
        {
          title: 'Matje LiDAR',
          description: 'Hartografim 3D i terrenit me precizion të lartë me kapur të dhënash point cloud. Ideal për matje topografike në shkallë të gjerë dhe analizë terreni kompleks.',
          icon: 'Scan'
        },
        {
          title: 'Fotogrametri',
          description: 'Përpunim i imazheve ajrore për harta ortofoto të sakta, modele digjitale sipërfaqe, dhe dokumentim të detajuar të vendit.',
          icon: 'Camera'
        },
        {
          title: 'Monitorim Ndërtimi',
          description: 'Ndiqni përparimin e projektit me matje të rregullta me dron. Matni volumet e punëve tokësore, monitoroni milestones, dhe siguroni kontroll cilësie.',
          icon: 'Building2'
        },
        {
          title: 'Matje Kadastrale',
          description: 'Hartografim i saktë i kufijve të pronës dhe dokumentim i regjistrimit të tokës. Përputhshmëri e plotë me standardet kadastrale shqiptare.',
          icon: 'MapPin'
        },
        {
          title: 'Inspektim Linjash Energjie',
          description: 'Inspektim i sigurt dhe efikas i linjave të transmetimit, kulllave, dhe infrastrukturës elektrike pa ndërprerje të shërbimit.',
          icon: 'Zap'
        },
        {
          title: 'Modelim 3D',
          description: 'Krijoni modele të detajuara 3D të ndërtesave, infrastrukturës, dhe terrenit për planifikim, dizajn, dhe dokumentim.',
          icon: 'Box'
        }
      ]
    },
    technology: {
      title: 'Teknologji e Avancuar LiDAR',
      subtitle: 'Saktësi dhe detaje të pakrahasueshme',
      description: 'Sensorët tanë të avancuar LiDAR kapin miliona pikë të dhënash për sekondë, duke ofruar saktësi në nivel centimetri për projekte të kërkuara matjeje. Ne kombinojmë platformat më të fundit të dronëve me sensorë me cilësi profesionale për të ofruar shërbimet më të besueshme të kapjes së të dhënave ajrore në Shqipëri.',
      features: [
        'Saktësi në nivel centimetri',
        'Kapur i shpejtë i të dhënave',
        'Aftësi në çdo mot',
        'Depërtim i bimësisë'
      ],
      cta: 'Mëso Më Shumë'
    },
    industries: {
      title: 'Industritë që Shërbejmë',
      subtitle: 'Zgjidhje të specializuara në sektorë të shumtë',
      items: [
        {
          title: 'Ndërtim & Zhvillim',
          description: 'Planifikim i vendit, monitorim përparimi, llogaritje volumetrike, dhe dokumentim as-built për projekte rezidenciale, komerciale, dhe infrastrukturore.',
          icon: 'HardHat'
        },
        {
          title: 'Energji & Shërbime',
          description: 'Inspektim linje energjie, monitorim fermash diellore, vlerësim turbi erë, dhe hartografim korridoresh transmetimi.',
          icon: 'Zap'
        },
        {
          title: 'Bujqësi',
          description: 'Monitorim kultivimi, planifikim ujitjeje, menaxhim toke, dhe aplikime bujqësie precize.',
          icon: 'Sprout'
        },
        {
          title: 'Minierat & Gurore',
          description: 'Matje volumi stoqeve, monitorim përparimi grope, dhe dokumentim përputhshmërie sigurie.',
          icon: 'Mountain'
        }
      ]
    },
    about: {
      title: 'Rreth Space Data',
      mission: {
        title: 'Misioni Ynë',
        description: 'Ne përfaqësojmë progres të pakufizuar – duke zhbllokuar potencialin e plotë të teknologjisë së dronëve dhe duke ekzekutuar sfida komplekse në të gjithë Shqipërinë. Ne jetojmë në ballë të teknologjisë dhe industrisë – duke pilotuar drejt një të ardhmeje të pakufizuar.'
      },
      why: {
        title: 'Pse Space Data',
        description: 'Sistemet tona gjithëpërfshirëse, burimet e bollshme, pilotët me përvojë, dhe masat e rrepta të sigurisë na pajisën plotësisht për të ekzekutuar me sukses çdo mision. Ne bëjmë të dhënat superiore ajrore më të aksesueshme dhe të përballueshme në mënyrë që partnerët tanë të kenë njohuri që u nevojiten për të inovuar, rritur dhe përshtatur. Standardet tona të patundura të saktësisë dhe besueshmërisë ndihmojnë në shërbimin tonë ndaj klientit – duke krijuar partneritete të besuara, bashkëpunuese që shtrihen në të gjithë vendin dhe nxisin përparimin.'
      }
    },
    why: {
      title: 'Pse të Zgjidhni Space Data',
      items: [
        {
          title: 'I Licensuar & Certifikuar',
          description: 'Operatorë dronësh plotësisht të licensuar me kredenciale profesionale matjeje',
          icon: 'Award'
        },
        {
          title: 'Dorëzim i Shpejtë',
          description: 'Kapur dhe përpunim i shpejtë i të dhënave me dorëzim në ditë, jo javë',
          icon: 'Clock'
        },
        {
          title: 'Precizion i Garantuar',
          description: 'Standarde saktësie lider në industri me protokolle kontrolli cilësie',
          icon: 'Target'
        },
        {
          title: 'Ekspertizë Lokale',
          description: 'Njohuri të thella të terrenit shqiptar, rregulloreve, dhe kërkesave të projektit',
          icon: 'Map'
        }
      ]
    },
    contact: {
      title: 'Kërkoni Ofertë',
      subtitle: 'Gati të filloni projektin tuaj? Kontaktoni sot',
      form: {
        firstName: 'Emri',
        lastName: 'Mbiemri',
        email: 'Adresa Email',
        phone: 'Numri Telefonit',
        company: 'Emri i Kompanisë',
        projectType: 'Lloji i Projektit',
        projectTypes: [
          'Matje LiDAR',
          'Fotogrametri',
          'Monitorim Ndërtimi',
          'Matje Kadastrale',
          'Inspektim Linje Energjie',
          'Modelim 3D',
          'Tjetër'
        ],
        description: 'Përshkrimi i Projektit',
        descriptionPlaceholder: 'Ju lutemi përshkruani projektin tuaj, vendndodhjen, mbulimin e zonës, dhe çdo kërkesë specifike...',
        timeline: 'Kur nevojitet projekti?',
        submit: 'Dërgo Kërkesën',
        success: 'Faleminderit! Do t\'ju kontaktojmë brenda 24 orëve.',
        error: 'Ju lutemi plotësoni të gjitha fushat e nevojshme.'
      }
    },
    footer: {
      tagline: 'Shërbime profesionale matjeje me dron në të gjithë Shqipërinë',
      services: 'Shërbimet',
      company: 'Kompania',
      companyLinks: ['Rreth Nesh', 'Karriera', 'Partnerët', 'Lajme'],
      contact: 'Kontakti',
      rights: 'Të gjitha të drejtat e rezervuara.',
      address: 'Tiranë, Shqipëri',
      email: 'info@spacedata.al',
      phone: '+355 69 242 2682'
    }
  }
};

export const heroImages = [
  'https://images.unsplash.com/photo-1723367194881-fe2e53534170?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzY5MTk3ODA2fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1711267250139-a91ab3db9772?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxhZXJpYWwlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzY5MTk3ODA2fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1706380003139-7471c33ca2b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxkcm9uZSUyMHN1cnZleWluZ3xlbnwwfHx8fDE3NjkxOTc3OTl8MA&ixlib=rb-4.1.0&q=85'
];

export const lidarImages = [
  'https://customer-assets.emergentagent.com/job_space-data-1/artifacts/6bly07t9_IMG-20250813-WA0046.jpg',
  'https://customer-assets.emergentagent.com/job_space-data-1/artifacts/9ttk8aya_IMG-20250813-WA0044.jpg',
  'https://customer-assets.emergentagent.com/job_space-data-1/artifacts/zhxw50r3_IMG-20250813-WA0045.jpg'
];

export const logoUrl = 'https://customer-assets.emergentagent.com/job_space-data-1/artifacts/o7fddx91_IMG-20250728-WA0000.jpg';
